import React from 'react';
import { Steps } from 'antd';

export const LCSteps = props => <Steps {...props} />;
